import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineM, LabelL } from '@sorare/core/src/atoms/typography';
import { OverlapItems } from '@sorare/core/src/atoms/ui/OverlapItems';

import cards from './assets/cards.svg';
import fire from './assets/fire.svg';
import trophy from './assets/trophy.svg';

const Root = styled(Vertical).attrs({ center: true })`
  padding: calc(10 * var(--unit)) 0;
`;

type Props = { hasClaimedTask?: boolean };
export const MissionsPageEmptyState = ({ hasClaimedTask }: Props) => {
  return (
    <Root>
      <OverlapItems offset={16}>
        <img src={cards} width={32} alt="" />
        <img src={trophy} width={32} alt="" />
        <img src={fire} width={32} alt="" />
      </OverlapItems>
      <Vertical gap={0} center>
        <HeadlineM>
          {hasClaimedTask ? (
            <FormattedMessage defaultMessage="Mission accomplished!" />
          ) : (
            <FormattedMessage defaultMessage="No missions available" />
          )}
        </HeadlineM>
        <LabelL color="var(--c-nd-600)" className="text-center">
          {hasClaimedTask ? (
            <FormattedMessage defaultMessage="All objectives cleared. Stay tuned for new challenges." />
          ) : (
            <FormattedMessage defaultMessage="New challenges are on the way. Stay tuned!" />
          )}
        </LabelL>
      </Vertical>
    </Root>
  );
};
